import React, { useState } from 'react';
import { AppStateUser } from '../../../client/providers/AppProvider';
import { Espin_Role_Enum } from '../../../generated/spin-graphql';
import { ComplimentMessagesIcon } from '../../svg/dashboard/messages/ComplimentMessagesIcon';
import { GeneralMessagesIcon } from '../../svg/dashboard/messages/GeneralMessagesIcon';
import { GreetingsMessagesIcon } from '../../svg/dashboard/messages/GreetingsMessagesIcon';
import { QuestionMessagesIcon } from '../../svg/dashboard/messages/QuestionMessagesIcon';
import { ResponseMessagesIcon } from '../../svg/dashboard/messages/ResponseMessagesIcon';
import { MessageButton } from './MessageButton';
import { ResponseSelector } from './ResponseSelector';

type Props = {
    user: AppStateUser;
    conversantName: string;
    setSelectedMessage: (message: string) => void;
    isLocked: boolean;
};

export enum ResponseType {
    GREETINGS = 'greetings',
    GENERAL = 'general',
    COMPLIMENTS = 'compliments',
    QUESTIONS = 'questions',
    RESPONSES = 'responses',
}

export const ConversationNavigation: React.FC<Props> = ({ user, conversantName, setSelectedMessage, isLocked }) => {
    const [responseType, setResponseType] = useState<ResponseType>(undefined);

    return (
        <>
            {isLocked && (
                <div className="max-messages">You cannot send more than 3 messages in a row without a reply.</div>
            )}
            {!isLocked && (
                <div
                    className={`conversation-navigation${
                        user.role === Espin_Role_Enum.EspinCollegeUser ? ' has-compliments' : ''
                    }`}
                >
                    <MessageButton
                        icon={<GreetingsMessagesIcon />}
                        label={'Greetings'}
                        onClick={() =>
                            setResponseType(
                                responseType === ResponseType.GREETINGS ? undefined : ResponseType.GREETINGS,
                            )
                        }
                        selected={responseType === ResponseType.GREETINGS}
                    />
                    <MessageButton
                        icon={<GeneralMessagesIcon />}
                        label={'General'}
                        onClick={() =>
                            setResponseType(responseType === ResponseType.GENERAL ? undefined : ResponseType.GENERAL)
                        }
                        selected={responseType === ResponseType.GENERAL}
                    />
                    {user.role === Espin_Role_Enum.EspinCollegeUser && (
                        <MessageButton
                            icon={<ComplimentMessagesIcon />}
                            label={'Compliments'}
                            onClick={() =>
                                setResponseType(
                                    responseType === ResponseType.COMPLIMENTS ? undefined : ResponseType.COMPLIMENTS,
                                )
                            }
                            selected={responseType === ResponseType.COMPLIMENTS}
                        />
                    )}
                    <MessageButton
                        icon={<QuestionMessagesIcon />}
                        label={'Questions'}
                        onClick={() =>
                            setResponseType(
                                responseType === ResponseType.QUESTIONS ? undefined : ResponseType.QUESTIONS,
                            )
                        }
                        selected={responseType === ResponseType.QUESTIONS}
                    />
                    <MessageButton
                        icon={<ResponseMessagesIcon />}
                        label={'Responses'}
                        onClick={() =>
                            setResponseType(
                                responseType === ResponseType.RESPONSES ? undefined : ResponseType.RESPONSES,
                            )
                        }
                        selected={responseType === ResponseType.RESPONSES}
                    />
                    {responseType && (
                        <ResponseSelector
                            user={user}
                            conversantName={conversantName}
                            responseType={responseType}
                            setSelectedMessage={(message) => {
                                setResponseType(undefined);
                                setSelectedMessage(message);
                            }}
                        />
                    )}
                </div>
            )}
        </>
    );
};
